document.addEventListener('DOMContentLoaded', function () {
  // Select all Buy Now buttons
  const buyNowButtons = document.querySelectorAll('button[name="checkout"], button[data-checkout="true"]');

  buyNowButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault(); // stop default checkout behavior

      // Find the product URL from the closest product card or form
      let productForm = button.closest('form[action*="/cart/add"]');
      if (productForm) {
        let productUrl = productForm.querySelector('input[name="id"]')?.value;
        if (productUrl) {
          // Construct Shopify product page URL
          const shopOrigin = window.shopUrl || '';
          window.location.href = `/products/${productForm.dataset.productHandle || ''}`;
        }
      }
    });
  });
});
